const init = () => {
    const $component = $('.c-book-block, .c-book-block-hero');
    if (!$component.length) return;

    // Handle image loading with CLS prevention
    initImageLoading();
    
    // Handle audiobook-specific styling
    handleAudiobookStyling();

    function initImageLoading() {
        // Handle image loading with CLS prevention
        const images = $component.find('img');
        images.each(function() {
            const $img = $(this);
            const $container = $img.closest('.c-book-block__thumb, .c-book-block-hero__thumb');
            
            if ($img[0].complete) {
                $img.addClass('loaded');    
                $container.addClass('image-loaded');
            } else {
                $img.on('load', function() {
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                });
                $img.on('error', function() {
                    // Still fade in on error to prevent infinite loading state
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                });
            }
        });
    }
    
    function handleAudiobookStyling() {
        // Check if the title contains 'audiobooks' (case insensitive)
        const $title = $component.find('.c-title-bar__title');
        if ($title.length && $title.text().toLowerCase().includes('audiobooks')) {
            // Set min-height for audiobook thumbnails
            $component.find('.c-book-block__thumb').css('min-height', '160px');
        }
    }
};

export default init;
